export default {
  MAIN_REQUEST: 'MAIN_REQUEST',
  MAIN_SUCCESS: 'MAIN_SUCCESS',
  MAIN_FAILURE: 'MAIN_FAILURE',
};



// WEBPACK FOOTER //
// ./src/redux/constants/MainConstants.js